// flag: unificar con canonicals, productTypes y utilidades
import { getClassQueryString, getCanonicalAlias } from '@finect/front-resources/Products';
import { slugs } from '../configs/iic';

// Home de productos
const getProductsMainPath = () => `/${slugs.products}`;

// Comparador
const getComparisonPath = productType =>
  (productType ? `/${productType.slug}/${slugs.comparison}` : `/${slugs.superComparison}`);

// Plus Supercomparador
const getPlusComparisonPath = () => `/plus/${slugs.comparison}`;

// Home para una tipología de producto
const getHomePath = productType => `/${productType.slug}`;

// Categorías
const getCategoriesPath = (productType, macrocategory = 'todos') =>
  `/${productType.slug}/${slugs.categories}/${macrocategory}`;

const getCategoryPath = (productType, category) =>
  `/${productType.slug}/${slugs.category}/${category.id}-${category.alias}`;

// Gestoras
const getManagementCompaniesPath = productType => `/${productType.slug}/${slugs.managementCompanies}`;

const getManagementCompanyPath = (productType, managementCompany) =>
  `/${productType.slug}/${slugs.managementCompanies}/${managementCompany.id}-${managementCompany.alias}`;

// Ficha — anclada al alias de la prime para evitar URLs no canónicas con siblings de restUrl divergente.
const getSheetPath = (productType, product) => {
  const canonicalAlias = getCanonicalAlias(product);
  return `/${productType.slug}/${product.isin}${canonicalAlias ? `-${canonicalAlias}` : ''}${getClassQueryString(
    product
  )}`;
};

const getSectionPathByProductType = productType => `/${productType.slug}`;

export {
  getProductsMainPath,
  getComparisonPath,
  getPlusComparisonPath,
  getHomePath,
  getCategoriesPath,
  getCategoryPath,
  getManagementCompanyPath,
  getManagementCompaniesPath,
  getSheetPath,
  getSectionPathByProductType
};
